export const ActivityEnums = {
  KPI: 'f3351dcb-a2a4-4602-020f-08dd66d6978c',
  SETTINGS: 'fe084e10-ee3c-4a48-0210-08dd66d6978c',
  BOOKING: '3232a847-e9d9-4c39-0215-08dd66d6978c',
  QUIZZ: 'cd136889-7176-4a18-4aa8-08ddaa267603',
  LESSON:'f81340a1-996e-4c91-0216-08dd66d6978c',
  SURVEY:'036149bf-532e-4b03-0211-08dd66d6978c',
  EDUCATION_RECORD:'06af8b3c-e3eb-4b5b-0212-08dd66d6978c',
  INFOGRAPHIC:'ba9f5b8c-f0e0-42d7-27bc-08ddacb69a26'

};

export const LogoDefault = {
  ImageDiaB: 'https://diab.com.vn/wp-content/uploads/2025/01/Logo_DiaB_800x800-03.png'
};


export const optionsKPIs = [
    { text: 'Đường huyết', value: 'BloodSugar' },
    { text: 'Huyết áp', value: 'BloodPressure' },
    { text: 'Cân nặng', value: 'Weight' },
    { text: 'Dinh dưỡng', value: 'Food' },
    { text: 'Vận động', value: 'Exercise' },
    { text: 'HbA1c', value: 'HbA1CInput' },
];


export const optionsSettings= [
        { text: 'Thực đơn mẫu', value: 'ScheduleMenuFood' },
        { text: 'Mục tiêu đo đường huyết', value: 'ScheduleBloodSugar' },
        { text: 'Mục tiêu vận động', value: 'ScheduleSetting' },
      ];
 export const optionsBooking= [
        { text: 'Đặt hẹn đầu vào', value: 'BookingOnboardingIn' },
        { text: 'Đặt hẹn đầu ra', value: 'BookingOnboardingOut' },
        { text: 'Đặt hẹn 1-1', value: 'BookingOnboardingFree' },
      ];
 export const  optionsReminders= [
        { text: 'Cho phép', value: 1 },
        { text: 'Không', value: 0 },
      ];

       export const  activityoptionsReminders= [
        { text: 'Zalo', value: 1 },
        { text: 'Notification App', value: 2 },
      ];